import { Box, Typography } from '@mui/material'
import _ from 'lodash'
import { memo, useMemo } from 'react'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */
import PrivilegeList from 'features/finance/payment/component/popupPaymentTemp/PrivilegeList'

/** UTILS */
import { numberFormat } from 'utils/app.utils'


type TreatmentDiscountType = {
  systemConfig: {
    isUseCrm: boolean
    isUseNhso: boolean
    patientCaseId: number
    menu: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
  }
  listOrder: any
  listOrderPayment: any
  handleCheckBox: (type: string, id: any) => void
  handleSelectBenefit: (treatmentRight: any) => void
  paidChannel: any
  itemChannel: any
  handleValueChannel: (value: any) => void
  handleValuePaidItem: (value: any, type: string, id: any, patientTreatmentRightId?: number) => void
  handleChangValueTreatmentRight?: (patientTreatmentRightId: number, value: any) => void
  handleCheckBoxItemTreatmentRight?: (patientTreatmentRightId: number, value: any, type: string, id: any) => void
  treatmentRights: any[]
  balancePaid?: number
  disableFiled?: boolean | false
  disableIcon?: boolean | false
  onChangePaid?: (val: number) => void
  dataPatientCase?: any
}

function TreatmentDiscount(props: TreatmentDiscountType) {
  const { t } = useTranslation()


  // ✅ OPTIMIZED: Memoized treatment rights with no discount message
  const hasNoTreatmentRights = useMemo(() =>
    props.treatmentRights.length === 0,
    [props.treatmentRights.length]
  )

  return (
    <Box className='mb-3'>
      <Typography className='mt-3' sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TREATMENT_DISCOUNT')}</Typography>
      <Box className='pl-xl-3' sx={{ marginTop: '-8px' }}>
        {!hasNoTreatmentRights ? (
          <>
            {_.map(props.treatmentRights, (treatmentRight, index) => {
              return (
                <PrivilegeList
                  listOrder={props.listOrder}
                  listOrderPayment={props.listOrderPayment}
                  paidChannel={props.paidChannel}
                  itemChannel={props.itemChannel}
                  handleCheckBox={props.handleCheckBox}
                  handleValueChannel={props.handleValueChannel}
                  handleValuePaidItem={(value: any, type: string, id: any) => {
                    props.handleValuePaidItem(value, type, id, treatmentRight.patientTreatmentRightId)
                  }}
                  handleSelectBenefit={props.handleSelectBenefit}
                  handleChangValueTreatmentRight={(value: any) => props.handleChangValueTreatmentRight?.(treatmentRight.patientTreatmentRightId, value)}
                  handleCheckBoxItemTreatmentRight={(value: any, type: string, id: any) => props.handleCheckBoxItemTreatmentRight?.(treatmentRight.patientTreatmentRightId, value, type, id)}
                  disableIcon={true}
                  systemConfig={{
                    ...props.systemConfig,
                    type: 'TreatmentDiscount'
                  }}
                  patientTreatmentRightId={treatmentRight.patientTreatmentRightId}
                  treatmentRight={treatmentRight}
                  index={index}
                  key={treatmentRight.patientTreatmentRightId || index}
                  title={!props.systemConfig.isUseNhso ? t('PAYMENT.FORM_PAYMENT.TITLE_DISCOUNT', { privilege: treatmentRight.treatmentRightName, price: numberFormat(treatmentRight.balance, 0, 0), unit: treatmentRight.isDivide === '1' ? (treatmentRight.unit === 'BAHT' && t('CURRENCY_CHANGE.TH') || '%') : t('PAYMENT.FORM_PAYMENT.TIMES') }) : `${treatmentRight.treatmentRightName}`}
                  disableFiled={props.disableFiled}
                  treatmentInfo={
                    t('PAYMENT.FORM_PAYMENT.TREATMENT_DISCOUNT_INFO', {
                      price: treatmentRight.isDivide === '1' ? treatmentRight.balance : treatmentRight.price,
                      unit: treatmentRight.unit === 'BAHT' ? ` ${t('CURRENCY_CHANGE.TH')}` : '%',
                      balance: treatmentRight.isDivide === '1' ? 1 : treatmentRight.balance,
                      unitIsDivide: treatmentRight.isDivide === '1' ? t('PAYMENT.FORM_PAYMENT.RIGHT') : t('PAYMENT.FORM_PAYMENT.TIMES'),
                      isNoDF: treatmentRight.isDoctorFee === '1' ? '' : t('PAYMENT.FORM_PAYMENT.OVERDUE_CONFIRM.NO')
                    })}
                  discountHasExpired={treatmentRight.balance < 1}
                  dataPatientCase={props.dataPatientCase}
                />
              )
            })}
          </>
        ) : (<div className='text-center p-2 mt-2 text-muted'>{t('PAYMENT.FORM_PAYMENT.NO_TREATMENT_DISCOUNT')}</div>)}

      </Box>
    </Box>
  )
}

export default memo(TreatmentDiscount)

